import { useMemo } from 'react';
import { hideLoginByLinkpass } from 'utils/enrichmentUtils';

const useLinkpassLoginHandler = () => {
  const visible = useMemo(() => {
    const isHideLinkpass = hideLoginByLinkpass();
    return !isHideLinkpass;
  }, []);

  return {
    visible,
  };
};

export default useLinkpassLoginHandler;
